import { Mode } from '../models/commons.models'

// http://front:3000/
const siteConfig = {
  mode: Mode.front,
}
export default siteConfig
